import Video, { CoverProps } from '../video';
import styles from './index.module.less';

interface IProps {
  coverProps: CoverProps;
}

/**
 * 视频封面
 * @returns
 */
export const CoverVideo: React.FC<IProps> = ({ coverProps }) => (
  <div className={styles.wrapper}>
    <div className={styles.left}>
      <Video {...coverProps} />
    </div>
  </div>
);
